module.exports = "/_next/static/images/landing1-tablet-288a38fc2ba68bb67c5db36060d0eb2a.png";